import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import api from "@/shared/api";
import { PaginatedResource, Resource } from "@/shared/types.ts";
import { UserEntity } from "@/features/users/type.ts";
import { CityEntity } from "@/features/city/type.ts";

export * from "./types.ts";

export function useOpenShiftCouriers({}: {}) {
  return useQuery<PaginatedResource<UserEntity[]>>({
    queryKey: ["open_shift_couriers"],
    queryFn: () =>
      api
        .get<PaginatedResource<UserEntity[]>>(`/api/v1/shift/open/couriers`)
        .json(),
    initialData: { data: [], total: 0 } as PaginatedResource<UserEntity[]>,
  });
}

type AssignOrder = {
  orderId: number;
  userId: string;
};

export function useAssignOrderToCouriers({
  onSuccess,
}: {
  onSuccess?: () => void;
}) {
  const queryClient = useQueryClient();

  return useMutation<Resource<CityEntity>, Error, AssignOrder>({
    mutationFn: (data: AssignOrder) =>
      api.post(`/api/v1/orders/accept`, { json: data }).json(),
    onSuccess: () => {
      onSuccess?.();
      queryClient.invalidateQueries({ queryKey: ["assign_orders"] });
    },
  });
}
